module.exports = __webpack_public_path__ + "img/light_m_footer_bg.070e5c8f.png";